// API configuration
// In production, API calls go through the _redirects file which proxies to the backend
// In development, proxy to local backend
export const API_BASE_URL = import.meta.env.VITE_API_URL || '';

// Helper to make API calls
export async function apiFetch(path: string, options?: RequestInit): Promise<Response> {
  // If path doesn't start with /api, add it
  const apiPath = path.startsWith('/api') ? path : `/api${path}`;
  const url = `${API_BASE_URL}${apiPath}`;
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
}
